import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "../axios/AxiosInstance";

export const CV_FOLLOWUP_PATH = "/actions-et-taches?onglet=cv";
const seenKey = () => `jm-cv-followup-seen:${localStorage.getItem("userId") || ""}`;
export const markCvFollowupSeen = () => {
  localStorage.setItem(seenKey(), new Date().toISOString());
  window.dispatchEvent(new Event("jm-cv-followup-seen"));
};

export default function CvPresentationNotifications() {
  const [count, setCount] = useState(0);
  const location = useLocation();
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await axios.get("cv-delivery/presentations");
        const seen = localStorage.getItem(seenKey()) || "1970-01-01";
        const total = data.reduce(
          (n, row) =>
            n +
            (row.events || []).filter(
              (e) =>
                e.at > seen && e.authorId !== localStorage.getItem("userId"),
            ).length,
          0,
        );
        if (active) setCount(total);
      } catch {}
    };
    load();
    const timer = setInterval(() => {
      if (!document.hidden) load();
    }, 15000);
    window.addEventListener("jm-cv-followup-seen", load);
    return () => {
      active = false;
      clearInterval(timer);
      window.removeEventListener("jm-cv-followup-seen", load);
    };
  }, [location.pathname]);
  return count ? (
    <Link
      to={CV_FOLLOWUP_PATH}
      onClick={() => window.dispatchEvent(new Event("jm-open-cv-followup"))}
      className="block rounded-lg bg-blue-50 p-3 mb-3 text-blue-900"
      role="status"
    >
      {count} nouveau(x) retour(s) sur les candidats proposés · Consulter le
      suivi
    </Link>
  ) : null;
}
